import { EntryModel, UserProfile } from "../models";

export interface AppState {
  entry: EntryModel | null;
  latestEntries: EntryModel[];
  query: string | null;
  workspaceNavigation: { uuid: string; refId: string; title: string }[];
  userProfile: UserProfile | null;
  userProfileNeedsReload: boolean;
}

export const DEFAULT_APP_STATE: AppState = {
  entry: null,
  latestEntries: [],
  query: null,
  workspaceNavigation: [],
  userProfile: null,
  userProfileNeedsReload: true,
};

export interface AppContextType {
  setEntry: (entry: EntryModel) => void;
  setQuery: (query: string) => void;
  setLatestEntries: (entries: EntryModel[]) => void;
  setWorkspaceNavigation: (
    paths: { uuid: string; refId: string; title: string }[],
  ) => void;
  setUserProfile: (userProfile: UserProfile) => void;
  setUserProfileNeedsReload: (needsReload: boolean) => void;
  state: AppState;
}
